<template>
    <div class="gift-list">
        <headerNotice routerName="活动列表"></headerNotice>
        <!-- 搜索框 -->
        <!-- <div class="seach-box">
            <div class="title-wrapper">
                <h2 class="title">
                    <i></i>
                    <span>筛选查询</span>
                </h2>
            </div>
            <div class="input-wrapper">
                <div>
                    <span>活动名称：</span>
                    <el-input class="el-search" v-model="searchInput" placeholder="活动名称"></el-input>
                </div>
                <div class="option-wrapper">
                    <span>活动分类：</span>
                    <el-select v-model="giftType" placeholder="全部">
                        <el-option
                            v-for="item in typeOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </div>
                <div class="option-wrapper">
                    <span>活动状态：</span>
                    <el-select v-model="giftStatus" placeholder="全部">
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </div>
                <el-button class="search-btn" @click="toSearch">查询</el-button>
            </div>
        </div> -->
        <!-- 活动列表 -->
        <div class="gift-list">
            <div class="head">
                <h2 class="title">
                    <i></i>
                    <span>数据列表</span>
                </h2>
                <el-button class="search-btn" @click="toAdd">添加</el-button>
            </div>
            <!-- 表格 -->
            <el-table
                v-loading="loading"
                ref="multipleTable"
                :data="giftList"
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleSelectionChange"
            >
                <el-table-column align="center" type="selection" width="55"></el-table-column>
                <!-- <el-table-column align="center" prop="image" label="活动图片" width="120">
                    <template slot-scope="scope">
                        <img :src="baseUrl+scope.row.image" width="100" height="100">
                    </template>
                </el-table-column> -->
                <el-table-column align="center" prop="name" label="名称"></el-table-column>
                   <el-table-column align="center" prop="gatherTogether" label="集齐人数"></el-table-column>
                <el-table-column align="center" prop="introduce" label="介绍"></el-table-column>
                 <el-table-column align="center" prop="startTime" label="开始时间"></el-table-column>
                  <el-table-column align="center" prop="endTime" label="结束时间"></el-table-column>
                <!-- <el-table-column align="center" label="活动状态">
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.status"
                            :active-value="1"
                            :inactive-value="2"
                            @change="UpdateBatchStatus([scope.row], scope.row.status, 0)"
                        ></el-switch>
                    </template>
                </el-table-column> -->
                <el-table-column align="center" prop="itemID" label="操作">
                    <template slot-scope="scope">
                        <el-button @click="toEdit(scope.row.truckActivityID)" type="text" size="small">编辑</el-button>
                        <!-- <el-button
                            @click="deleteTemplateItem(scope.row.itemID)"
                            type="text"
                            size="small"
                        >删除</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog title="活动详情" :visible.sync="showDetail"></el-dialog>
        <!--分页-->
        <div class="pagination-wrapper">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[10, 20, 30, 40]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
                center
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import headerNotice from "../../components/common/headerNotice.vue";
export default {
    components: {
        headerNotice
    },
    props: {},
    data() {
        return {
            loading: false,
            btnLoading: false,
            totalCount: 0,
            pageSize: 10,
            currentPage: 1,
            showDetail: false,
            searchInput: '',
            giftList: [],
            multipleSelection: [],
            options: [
                { value: 0, label: "全部" },
                { value: 1, label: "上架" },
                { value: 2, label: "下架" }
            ],
            typeOption: [{ value: 0, label: "全部" }],
            giftType: 0,
            giftStatus: 0,
              baseUrl: this.$store.state.URL,
        };
    },
    watch: {},
    computed: {},
    methods: {
        toSearch() {
            let params = {
                Title: this.searchInput,
                CateID: this.giftType,
                Status: this.giftStatus,
                MaxResultCount: this.pageSize,
                SkipCount: 0
            }
            this.getAdminTemplateItem(params)
            this.currentPage = 1
        },
        toEdit(id) {
            this.$router.push({
                path: "/addActivty",
                query: {
                    Id: id
                }
            })
        },
        toAdd() {
            this.$router.push({ path: "/addActivty" })
        },
        // 切换状态
        UpdateBatchStatus(selected, status, isMultiple) {
            if (!selected.length) {
                this.$message.error('请至少勾选一项')
                return
            }
            let itemID = []
            selected.forEach((item) => {
                itemID.push(item.itemID)
            })
            let data = {
                itemID: itemID,
                status: status
            }
            let self = this;
            if (isMultiple) {
                self.btnLoading = true
            }
            $http.PUT({
                url:
                    this.$store.state.apiUrl +
                    "/api/services/app/AdminTemplateExchange/UpdateBatchStatus",
                data: data,
                success(res) {
                    // console.log(res);
                    self.$message.success('操作成功！')
                    if (isMultiple) {
                        selected.forEach((item) => {
                            item.status = status
                        })
                        self.btnLoading = false
                    }
                },
                fail(res) {
                    if (isMultiple) {
                        self.btnLoading = false;
                    }
                }
            });
        },
        // 删除
        deleteTemplateItem(id) {
            let params = {
                Id: id
            }
            let self = this;
            this.$confirm('此操作将永久删除该项, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                $http.DELETE({
                    url:
                        this.$store.state.apiUrl +
                        "/api/services/app/AdminTemplateExchange/DeleteTemplateItem",
                    params: params,
                    success(res) {
                        self.$message.success('操作成功！')
                        let params = {
                            Title: self.searchInput,
                            CateID: self.giftType,
                            Status: self.giftStatus,
                            MaxResultCount: self.pageSize
                        }
                        self.getAdminTemplateItem(params)
                        self.currentPage = 1
                        // self.loading = false
                    },
                    fail(res) {
                        // self.loading = false;
                    }
                });

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        //获取活动列表
        getAdminTemplateItem(params) {
            let self = this;
            self.loading = true
            $http.GET({
                url:
                    this.$store.state.apiUrl +
                    "/api/services/app/TruckActivity/GetTruckActivityList",
                params: params,
                success(res) {
                    // console.log(res);
                    self.giftList = self.dealGiftData(res.items)
                    self.totalCount = res.totalCount
                    self.loading = false
                },
                fail(res) {
                    self.loading = false;
                }
            });
        },
        // 处理活动数据
        dealGiftData(data) {
            data.forEach((item) => {
                item.fileName = this.$store.state.apiUrl + item.fileName
            })
            return data
        },
        handleSelectionChange(val) {
            this.multipleSelection = val
        },
        //一页显示多少个
        handleSizeChange(val) {
            this.maxResultCount = val;
            let params = {
                Title: this.searchInput,
                CateID: this.giftType,
                Status: this.giftStatus,
                MaxResultCount: val
            }
            this.getAdminTemplateItem(params)
        },
        //跳转到指定页
        handleCurrentChange(val) {
            let skipCount = (val - 1) * this.pageSize;
            let params = {
                Title: this.searchInput,
                CateID: this.giftType,
                Status: this.giftStatus,
                SkipCount: skipCount,
                MaxResultCount: this.pageSize
            }
            this.getAdminTemplateItem(params)
        },
        statusFilter(status) {
            return status == 1 ? "待处理" : (status == 2 ? '处理中' : '已处理');
        }
    },
    created() {
        this.getAdminTemplateItem({
            MaxResultCount: this.pageSize
        })
    },
    mounted() { }
};
</script>
<style lang="scss" scoped>
.gift-list {
    // 搜索
    .seach-box {
        border: 1px solid rgba(228, 228, 228, 1);
        margin: 20px 50px;
        .title-wrapper {
            // display: flex;
            // align-items: center;
            // justify-content: space-between;
            height: 50px;
            background-color: rgba(243, 243, 243, 1);
            border-bottom: 1px solid rgba(228, 228, 228, 1);
            padding: 0 20px;
        }
        .title {
            display: flex;
            height: 50px;
            align-items: center;
            font-weight: 400;
            // i:first-child {
            //   width: 18px;
            //   height: 18px;
            //   background: green;
            // }
        }
        .input-wrapper {
            display: flex;
            align-items: center;
            height: 60px;
            padding-left: 40px;
            .el-search {
                width: 180px;
            }
            .option-wrapper {
                margin-left: 40px;
            }
            .option-wrapper:last-of-type {
                margin-right: 40px;
            }
        }
    }

    // 活动列表
    .gift-list {
        margin: 0 50px;
        border: 1px solid rgba(228, 228, 228, 1);
        font-weight: 400;
        .head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: rgba(243, 243, 243, 1);
            border-bottom: 1px solid rgba(228, 228, 228, 1);
            padding-right: 20px;
            .title {
                display: flex;
                align-items: center;
                height: 50px;
                font-weight: 400;
                padding-left: 20px;
                // i:first-child {
                //   width: 18px;
                //   height: 18px;
                //   background: green;
                // }
            }
        }
    }
    .pagination-wrapper {
        text-align: center;
        margin-top: 20px;
    }
}
</style>